import Vue from "vue";
import { Doughnut, Line } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  ArcElement,
  CategoryScale,
  PointElement
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  ArcElement,
  CategoryScale,
  PointElement
);

Vue.component("doughnut-chart", {
  extends: Doughnut, 
});

Vue.component("line-chart", {
  extends: Line, 
});